"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Jellyfin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralCommandType = void 0;
/**
 * This exists simply to identify a set of known commands.
 * @export
 * @enum {string}
 */
var GeneralCommandType;
(function (GeneralCommandType) {
    GeneralCommandType["MoveUp"] = "MoveUp";
    GeneralCommandType["MoveDown"] = "MoveDown";
    GeneralCommandType["MoveLeft"] = "MoveLeft";
    GeneralCommandType["MoveRight"] = "MoveRight";
    GeneralCommandType["PageUp"] = "PageUp";
    GeneralCommandType["PageDown"] = "PageDown";
    GeneralCommandType["PreviousLetter"] = "PreviousLetter";
    GeneralCommandType["NextLetter"] = "NextLetter";
    GeneralCommandType["ToggleOsd"] = "ToggleOsd";
    GeneralCommandType["ToggleContextMenu"] = "ToggleContextMenu";
    GeneralCommandType["Select"] = "Select";
    GeneralCommandType["Back"] = "Back";
    GeneralCommandType["TakeScreenshot"] = "TakeScreenshot";
    GeneralCommandType["SendKey"] = "SendKey";
    GeneralCommandType["SendString"] = "SendString";
    GeneralCommandType["GoHome"] = "GoHome";
    GeneralCommandType["GoToSettings"] = "GoToSettings";
    GeneralCommandType["VolumeUp"] = "VolumeUp";
    GeneralCommandType["VolumeDown"] = "VolumeDown";
    GeneralCommandType["Mute"] = "Mute";
    GeneralCommandType["Unmute"] = "Unmute";
    GeneralCommandType["ToggleMute"] = "ToggleMute";
    GeneralCommandType["SetVolume"] = "SetVolume";
    GeneralCommandType["SetAudioStreamIndex"] = "SetAudioStreamIndex";
    GeneralCommandType["SetSubtitleStreamIndex"] = "SetSubtitleStreamIndex";
    GeneralCommandType["ToggleFullscreen"] = "ToggleFullscreen";
    GeneralCommandType["DisplayContent"] = "DisplayContent";
    GeneralCommandType["GoToSearch"] = "GoToSearch";
    GeneralCommandType["DisplayMessage"] = "DisplayMessage";
    GeneralCommandType["SetRepeatMode"] = "SetRepeatMode";
    GeneralCommandType["ChannelUp"] = "ChannelUp";
    GeneralCommandType["ChannelDown"] = "ChannelDown";
    GeneralCommandType["Guide"] = "Guide";
    GeneralCommandType["ToggleStats"] = "ToggleStats";
    GeneralCommandType["PlayMediaSource"] = "PlayMediaSource";
    GeneralCommandType["PlayTrailers"] = "PlayTrailers";
    GeneralCommandType["SetShuffleQueue"] = "SetShuffleQueue";
    GeneralCommandType["PlayState"] = "PlayState";
    GeneralCommandType["PlayNext"] = "PlayNext";
    GeneralCommandType["ToggleOsdMenu"] = "ToggleOsdMenu";
    GeneralCommandType["Play"] = "Play";
})(GeneralCommandType = exports.GeneralCommandType || (exports.GeneralCommandType = {}));
